import React from "react";
import styles from './inputSlider.module.css';

const InputSlider = (props) => {

    const { label, display, ...otherProps } = props;
    return(
        <table
            className={styles.sliderTable}
        >
            <tbody>   
            <tr>
                <td className={styles.rangeLabel}>
                   {label}
                </td>
                <td>
                    <input 
                        type="range" 
                        className={styles.slider}
                        {... otherProps}
                    />
                </td>
                <td className={styles.rangeLabel}>
                    {display}
                </td>
            </tr>
            </tbody>
        </table>);
}

export default InputSlider;
